import { useState } from 'react';
import { Text } from '~/components/typography';
import { ValidatingInput } from '~/components/validating-input';

export interface OptInToSmsCheckboxProps {
  onChange: (value: boolean, { name, isValid }) => void;
  checked?: boolean;
  initialValue?: boolean;
}
export const OptInToSmsCheckbox = (props: OptInToSmsCheckboxProps) => {
  const { onChange, initialValue = false } = props;
  const [optInToSMS, setOptInToSMS] = useState(initialValue);
  const validate = () => {
    return true;
  };

  return (
    <ValidatingInput
      {...props}
      type="checkbox"
      label=""
      name="optInToSMS"
      value={optInToSMS}
      onChange={value => {
        setOptInToSMS(!!value);
        onChange(!!value, { name: 'optInToSMS', isValid: true });
      }}
      validate={validate}
    >
      <Text textStyle="paragraph400" color="secondary">
        By clicking this box, Subscriber expressly agrees, consents and permits Arcadia to contact
        Subscriber, at the numbers and addresses provided by Subscriber for Subscription and
        promotional purposes including through the use of e-mail and text messages (sms/mms), push
        notifications, phone calls, AI generated voice calls and messages, and prerecorded and/or
        artificial voice messages. Subscriber agrees that any such communications may be generated
        by automated systems (i.e., any form of “automatic telephone dialing system” (“ATDS”) or
        auto dialer) and be recorded for quality and compliance purposes. Subscriber understands and
        acknowledges that Subscriber’s consent to receive promotional communications is not a
        prerequisite to community solar program participation. Appropriate opt-out instructions are
        available for review in Section 19 of the TOS and shall be provided within any such
        promotional communications. Further, Subscriber can call Arcadia's support center toll-free
        at 866-526-0083 to subscribe without providing such consent.
      </Text>
    </ValidatingInput>
  );
};
